import { createSlice } from "@reduxjs/toolkit";

const coupaFileUploadSlice = createSlice({
  name: "coupaFileUpload",
  initialState: {
    coupaFile: {
      coupaFileName: "",
      coupaFileContent: "",
    },
    fileUploadedStatus: false,
    isLoading: false,
    successMessage: undefined,
    errorMessage: undefined,
  },
  reducers: {
    setCoupaFileUploadStart: (state) => {
      state.isLoading = true;
      state.errorMessage = undefined;
      state.successMessage = undefined;
    },
    setCoupaFile: (state, action) => {
        state.coupaFile = action.payload;
        state.fileUploadedStatus = true;
    },
    setCoupaFileUploadSuccess: (state, action) => {
      state.isLoading = false;
      state.errorMessage = undefined;
      state.successMessage = action.payload;
    },
    setCoupaFileUploadFailure: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
      state.successMessage = undefined;
    },
    resetCoupaFileUpload: (state) => {
      state.coupaFile = {
        coupaFileName: "",
        coupaFileContent: "",
      };
      state.fileUploadedStatus = false;
      state.isLoading = false;
      state.errorMessage = undefined;
      state.successMessage = undefined;
    },
  },
});

export const {
  setCoupaFile,
  setCoupaFileUploadStart,
  setCoupaFileUploadSuccess,
  setCoupaFileUploadFailure,
  resetCoupaFileUpload,
} = coupaFileUploadSlice.actions;

export default coupaFileUploadSlice.reducer;
